import { Component, ElementRef, inject, OnInit } from '@angular/core';

import { _BarClassicWidgetsEngine } from './bar-classic-widgets-engine.provider';
import { _BarBurgerprofielEngine } from './burgerprofiel/bar-burgerprofiel-engine-provider';

@Component({
    selector: 'baas-global-footer',
    standalone: true,
    template: ''
})
export class BaasGlobalFooter implements OnInit {
    readonly #elRef = inject(ElementRef);
    readonly #burgerprofielEngine = inject(_BarBurgerprofielEngine);
    readonly #classicWidgetsEngine = inject(_BarClassicWidgetsEngine);

    ngOnInit(): void {
        // burgerprofiel header
        if (this.#burgerprofielEngine.visible) this.#burgerprofielEngine.tryMountFooter(this.#elRef.nativeElement);
        // classic header
        else this.#classicWidgetsEngine.tryMountFooter(this.#elRef.nativeElement);
    }
}
